








































import { Component, Vue, Prop } from "vue-property-decorator";
import { PlanSchedule } from "@foxone/api/src/models/hfox";
import { Colors } from "@/types";
import utils from "hfox/utils";
import { USDT_ASSET } from "hfox/constants";

@Component
class ScheduleItem extends Vue {
  @Prop() schedule!: PlanSchedule;

  get meta() {
    const kind = utils.plan.getScheduleTypeMeta(this.schedule.kind);
    return {
      usdtSymbol: USDT_ASSET.symbol,
      filledFunds: this.schedule.filled_funds,
      amount: this.schedule.amount,
      price: this.schedule.price || "-",
      symbol: this.schedule.etf_name,
      color: this.color,
      kindText: this.$t(kind.text),
      kindColor: kind.color,
      time: this.$common.utils.date.formatDate(
        this.schedule.created_at * 1000,
        "YYYY/MM/DD"
      )
    };
  }

  get color() {
    const status = this.schedule.status;
    switch (status) {
      case "TIMEOUT":
        return Colors.RED;
      case "PENDING":
        return Colors.WARNING;
      case "FILLED":
        return Colors.GREEN;
      case "PAID":
        return Number(this.schedule.filled_funds) > 0
          ? Colors.WARNING
          : Colors.RED;
    }
    return "";
  }
}
export default ScheduleItem;
